import { ActionIcon, Badge, Box, Container, Grid, Group, Image, Stack, Text } from '@mantine/core';
import {
  IconBrandFacebook,
  IconBrandInstagram,
  IconBrandTwitter,
  IconBrandYoutube,
} from '@tabler/icons-react';
import image from '../../assets/images/web_logo.jpg';

export default function Header() {
  return (
    <>
      <Container fluid px="md" py="lg">
        <Grid align="center" gutter="md">
          {/* Social Icons */}
          <Grid.Col span={{ base: 12, md: 3 }} order={{ base: 2, md: 1 }}>
            <Box style={{ display: 'flex', justifyContent: 'center' }}>
              <Group>
                <ActionIcon
                  component="a"
                  href="https://www.youtube.com/@JanardanswamiYogabhyasiMandal?sub_confirmation=1"
                  target="_blank"
                  size="lg"
                  color="#937e26"
                  radius="xl"
                >
                  <IconBrandYoutube size={24} />
                </ActionIcon>
                <ActionIcon
                  component="a"
                  href="https://facebook.com/jsyog/"
                  target="_blank"
                  size="lg"
                  color="#937e26"
                  radius="xl"
                >
                  <IconBrandFacebook size={24} />
                </ActionIcon>
                <ActionIcon
                  component="a"
                  href="https://www.instagram.com/jsyogorg/"
                  target="_blank"
                  size="lg"
                  color="#937e26"
                  radius="xl"
                >
                  <IconBrandInstagram size={24} />
                </ActionIcon>
                <ActionIcon
                  component="a"
                  href="https://twitter.com/jsyog/"
                  target="_blank"
                  size="lg"
                  color="#937e26"
                  radius="xl"
                >
                  <IconBrandTwitter size={24} />
                </ActionIcon>
              </Group>
            </Box>
          </Grid.Col>

          {/* Logo */}
          <Grid.Col span={{ base: 12, md: 6 }} order={{ base: 1, md: 2 }}>
            <Box style={{ textAlign: 'center' }}>
              <Image src={image} alt="JSYOG Logo" height={100} fit="contain" mx="auto" />
            </Box>
          </Grid.Col>

          {/* Contact Info */}
          <Grid.Col span={{ base: 12, md: 3 }} order={{ base: 3, md: 3 }}>
            <Stack align="center" gap={8} mt={{ base: 'sm', md: 40 }}>
              <Badge size="lg" color="#937e26" variant="filled">
                CALL +91 95457 23332
              </Badge>
              <Text c="dimmed" size="sm" ta="center">
                Timings 9:00 a.m - 7:00 p.m
              </Text>
            </Stack>
          </Grid.Col>
        </Grid>
      </Container>

      {/* Bottom Banner */}
    </>
  );
}
